import React from 'react';
import { useIntl } from 'react-intl';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Skeleton shown while the portfolio user member list loads or retries.
 * @returns {React.ReactNode} Placeholder content.
 */
function PortfolioUserMemberListPlaceholder() {
  const intl = useIntl();
  const portfolioLabel = intl.formatMessage({
    id: 'portfolio.portfolio_show.portfolio_user_member_list.placeholder.breadcrumbs.portfolios.label',
    defaultMessage: 'Portfolios',
  });
  const usersLabel = intl.formatMessage({
    id: 'portfolio.portfolio_show.portfolio_user_member_list.placeholder.heading.users.title',
    defaultMessage: 'Users',
  });

  return (
    <div aria-hidden="true" inert>
      <Breadcrumbs breadcrumbs={[{ name: portfolioLabel, path: '/portfolios' }, { name: usersLabel }]} />
      <Heading title={usersLabel} subtitle={<span className="placeholder placeholder-glow bg-darken col-4" />} />
      <div className="d-flex gap-2 mb-3">
        <div className="placeholder placeholder-glow bg-darken col-2" style={{ height: '2rem' }} />
        <div className="placeholder placeholder-glow bg-darken col-2" style={{ height: '2rem' }} />
      </div>
      <div className="table-responsive card">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">{intl.formatMessage({ id: 'portfolio.portfolio_show.portfolio_user_member_list.placeholder.table.user.label', defaultMessage: 'User' })}</th>
              <th scope="col">{intl.formatMessage({ id: 'portfolio.portfolio_show.portfolio_user_member_list.placeholder.table.active.label', defaultMessage: 'Active' })}</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map((row) => (
              <tr key={row}>
                <td aria-hidden="true"><span className="placeholder placeholder-glow bg-darken col-8" /></td>
                <td aria-hidden="true"><span className="placeholder placeholder-glow bg-darken col-5" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PortfolioUserMemberListPlaceholder;
